module.exports = __webpack_public_path__ + "static/media/ico-home.0bc7a99c.svg";